<div class="photo">
    <img
        *ngIf="product.photos.items.length; else noImage"
        [src]="product.photos.items[0].url"
    />
</div>
<span class="name">{{product.name}}</span>
<span
    [style.opacity]="product.ean ? 1 : 0"
    class="ean"
>EAN: {{product.ean}}</span>
<span class="offers">{{formatedShopsCount}}</span>
<div class="cta">
    <button
        class="remove"
        *ngIf="isSelected else isNotSelected"
        mat-flat-button
        color="primary"
        (click)="onRemove.emit(product.id)"
    ><mat-icon>checked</mat-icon>usuń</button>
    <ng-template #isNotSelected>
        <button
            class="select"
            mat-flat-button
            (click)="onSelect.emit(product)"
        >wybierz</button>
    </ng-template>
</div>
<ng-template #noImage>
    <div class="no-image">
        <mat-icon class="material-symbols-outlined"> image_not_supported </mat-icon>
        <span>brak zdjęcia</span>
    </div>
</ng-template>